import { registerLicense } from '@syncfusion/ej2-base';

registerLicense('Ngo9BigBOggjHTQxAR8/V1NDaF5cWWtCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWH9fcXRdRWRdVUJwVks=');

import { setCulture, loadCldr } from '@syncfusion/ej2-base';

import { default as n1 } from 'cldr-data/main/en-NZ/currencies.json'
import { default as n2 } from 'cldr-data/main/en-NZ/timeZoneNames.json';
import { default as n3 } from 'cldr-data/main/en-NZ/numbers.json';
import { default as n4 } from 'cldr-data/main/en-NZ/ca-gregorian.json';
import { default as s } from 'cldr-data/supplemental/currencyData.json';
import { default as s2 } from 'cldr-data/supplemental/numberingSystems.json';

loadCldr(n1, n2, n3, n4, s, s2);
setCulture('en-NZ');

import "./syncfusionOverrides.css";
